import { Breadcrumbs, Box, Typography, Link, Stack } from "@mui/joy";
import { useTranslation } from "../../../i18n";
import { useAllBrandsQuery } from "../../../__generated__/types-and-hooks";
import BrandMiniCard from "./BrandMiniCard";
import { Link as RouterLink } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import OnlineUsersToggle from "../../../components/OnlineUsersToggle";
import Users from "./Users";

export default function Network() {
  const t = useTranslation();
  const { data, loading } = useAllBrandsQuery();

  return (
    <>
      <Stack direction="row">
        <Breadcrumbs
          aria-label="breadcrumbs"
          sx={{
            "--Breadcrumbs-gap": "4px",
            m: 1,
          }}
          size="sm"
        >
          <Link component={RouterLink} color="neutral" to="/">
            <HomeIcon />
          </Link>
          <Typography level="title-sm">{t("Network")}</Typography>
        </Breadcrumbs>
        <OnlineUsersToggle />
      </Stack>
      <Box sx={{ m: 2 }}>
        <Typography sx={{ flex: 1 }} level="body-sm">
          {t("Explore Agencies & Brands")}
        </Typography>
      </Box>
      <Box sx={{ m: 2 }}>
        {loading && "Loading..."}
        {!loading && (
          <Box
            sx={{
              width: "100%",
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fill, minmax(min(100%, 200px), 1fr))",
              gap: 2,
              marginBottom: 3,
            }}
          >
            {(data?.team_list?.teams ?? []).map((team) => (
              <BrandMiniCard
                key={team.id}
                name={team.name}
                slug={team.slug}
                picture={team.picture}
                description={team.description}
                createdAt={team.createdAt}
                kind={team.kind}
                contacts={team.contacts}
              />
            ))}
          </Box>
        )}
      </Box>
      <Users />
    </>
  );
}
